import React from 'react';
import PropTypes from 'prop-types';
import PartialTable from 'components/partials/PartialTable';
import Flex from 'components/common/Flex';
import { useNavigate } from 'react-router-dom';

const Table = ({
  data,
  paging,
  total,
  nextPage,
  previousPage,
  gotoPage,
  onPageSizeChange
}) => {
  const navigate = useNavigate();
  const columns = [
    {
      accessor: 'supplierCode',
      Header: 'Supplier Code',
      Cell: rowData => {
        const { supplierCode } = rowData.row.original;
        return (
          <Flex alignItems="center">
            <h5 className="mb-0 fs--1 text-primary">{supplierCode}</h5>
          </Flex>
        );
      }
    },
    {
      accessor: 'supplierName',
      Header: 'Supplier Name'
    },
    {
      accessor: 'contactName',
      Header: 'Contact Name'
    },
    {
      accessor: 'contactPosition',
      Header: 'Contact Position'
    },
    {
      accessor: 'telephone',
      Header: 'Telephone'
    },
    {
      accessor: 'mobile',
      Header: 'Mobile'
    },
    {
      accessor: 'importDataFrom',
      Header: 'Import From',
      Cell: rowData => {
        const { isFromEva, isFromWd } = rowData.row.original;
        return (
          <Flex alignItems="center" wrap="wrap" style={{ gap: '4px' }}>
            {isFromEva && <span className="badge bg-success">EVA</span>}
            {isFromWd && <span className="badge bg-primary">WD</span>}
          </Flex>
        );
      }
    },
    {
      accessor: 'actions',
      Header: 'Actions',
      Cell: rowData => {
        return (
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={() =>
              navigate(
                `/supplier/supplier-details/${rowData.row.original.supplierId}`
              )
            }
          >
            View Detail
          </button>
        );
      }
    }
  ];

  return (
    <PartialTable
      data={data}
      columns={columns}
      paging={paging}
      total={total}
      nextPage={nextPage}
      previousPage={previousPage}
      gotoPage={gotoPage}
      onPageSizeChange={onPageSizeChange}
    />
  );
};

Table.propTypes = {
  data: PropTypes.array,
  paging: PropTypes.object,
  total: PropTypes.number,
  nextPage: PropTypes.func,
  previousPage: PropTypes.func,
  gotoPage: PropTypes.func,
  onPageSizeChange: PropTypes.func
};

export default Table;
